import React from "react";
import Skeleton from "react-loading-skeleton";

const CartPageSkeleton: React.FC = () => (
  <div className="cart-page cart-page-skeleton">
    <h1 className="cart-page__title">
      <Skeleton width={120} />
    </h1>
    <div className="cart-page__content cart-page-skeleton__content">
      {/* Table Skeleton */}
      <div className="cart-page-skeleton__table">
        <div className="cart-page-skeleton__table-header">
          <Skeleton height={30} />
        </div>
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="cart-page-skeleton__row">
            <div className="cart-page-skeleton__product-info">
              <Skeleton width={80} height={80} />
              <div className="cart-page-skeleton__product-details">
                <Skeleton width="60%" />
                <Skeleton width="40%" />
              </div>
            </div>
            <Skeleton width={80} />
            <Skeleton width={70} />
            <Skeleton width={100} />
            <Skeleton circle width={32} height={32} />
          </div>
        ))}
      </div>

      {/* Totals Skeleton */}
      <div className="cart-page__totals cart-page-skeleton__totals">
        <h2 className="cart-page__totals-title cart-page-skeleton__totals-title">
          <Skeleton width={150} />
        </h2>
        <div className="cart-page-skeleton__totals-line">
          <Skeleton height={24} />
        </div>
        <div className="cart-page-skeleton__totals-line">
          <Skeleton height={28} />
        </div>
        <Skeleton height={48} />
      </div>
    </div>
  </div>
);

export default CartPageSkeleton;
